module.exports = __webpack_public_path__ + "static/media/teacher-comp-banner-x1.00f75477.jpg";